import { Typography } from '@mui/material';
import { useMemo } from 'react';

export default function ModelName(props) {
  const {
    component,
    name,
    variant,
    sx,
    noWrap = true,
  } = props;
  const html = useMemo(
    () => (isNModel(name)
      ? replaceTextWithSVG(name, variant)
      : name),
    [name, variant],
  );

  return (
    <Typography
      component={component || 'div'}
      dangerouslySetInnerHTML={{ __html: html }}
      sx={{
        whiteSpace: noWrap ? 'nowrap' : 'none',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'flex',
        alignItems: 'center',
        ...sx,
      }}
      variant={variant}
    />
  );
}

export function isNModel(name) {
  return REGEX.test(name)
    && !name.includes('N-Line')
    && !name.includes('N Line');
}

function replaceTextWithSVG(content, variant) {
  const svgPath = '/images/hyundai-n-logo.svg';
  const { w, h } = VARIANT_MAP[variant || 'default'] || VARIANT_MAP.default;
  return content.replace(REGEX, `<img width="${w}" height="${h}" src="${svgPath}" alt="N" />`);
}

const REGEX = /(^|\s)N(\s|$)/;

const VARIANT_MAP = {
  default: {
    w: 40,
    h: 25,
  },
  h3: {
    w: 72,
    h: 45,
  },
};
